// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".inputs-container {\n  border: 1px solid rgba(255,255,255,0.08);\n}\n.divider {\n  margin: 10px 0 !important;\n}\n@media (max-width: 600px) {\n.inputs-container {\n    flex-direction: column !important;\n}\n.arrow {\n    display: none;\n}\n.origin {\n    margin-bottom: 40px;\n}\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
